import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'lookup-document-preview-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lookup-document-preview-modal.component.html',
  styleUrls: ['./lookup-document-preview-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LookupDocumentPreviewModalComponent {
  @Input() title = 'View Document';
  @Input() previewUrl: SafeResourceUrl | null = null;
  @Input() isImage = false;

  constructor(public activeModal: NgbActiveModal) {}
}
